import React from 'react';
import Layout from '../../components/Layout';
import TextStyle from '@rezdy/components/TextStyle';
import { H4 } from '@rezdy/components/Heading';
import Button from '@rezdy/components/Button';
import auth from '../../services/auth';
import routing from '../../services/routing';
import { SIGN_IN } from '../../constants/routes';
import { withTranslation, WithTranslation } from 'react-i18next';
export class ConfirmEmailChange extends React.Component<WithTranslation> {
    async componentDidMount() {
        await auth.signOut();
    }

    handleClick = () => {
        routing.push(SIGN_IN);
    };

    render(): React.ReactNode {
        const { i18n } = this.props;
        return (
            <Layout>
                <TextStyle align="center">
                    <H4>{i18n.t('messages.emailModified')}</H4>
                </TextStyle>
                <Button type="submit" action="primary" onClick={this.handleClick}>
                    {i18n.t('primaryAction', { context: 'loginDashboard' })}
                </Button>
            </Layout>
        );
    }
}

export default withTranslation()(ConfirmEmailChange);
